<template>
    <div>
        <menutab :dataView="dataMenu"></menutab>
    </div>
</template>
<script>
import menutab from "@/components/dimenu/menu/menu_tab";
export default {
    name: "Menu",
    components: {
        menutab,
    },
    data () {
        return {
            isLoading: false,
            dataMenu: {
                retorno: 1,
                nom: "Menu",
                options: [],
            },
        };
    },
    created () {
        this.dataMenu.options.push({
            id: 1,
            name: window.lang2.label_list_group,
            ruta: "#",
        });
        this.dataMenu.options.push({
            id: 2,
            name: window.lang2.label_extras,
            ruta: "#",
        });
        this.dataMenu.options.push({
            id: 3,
            name: window.lang2.label_variants,
            ruta: "#",
        });
    },
}
</script>
<style lang="scss" scoped>
.extra {
    display: block;
    margin: auto;
}
</style>
